const CustomerServices = {
  name: 'Customer Services',
  links: [
    {
      title: 'Express Delivery',
      href: '#'
    },
    {
      title: 'Privacy Statement',
      href: '#'
    },
    {
      title: 'Terms of Use',
      href: '#'
    },
    {
      title: 'Pricing Policy',
      href: '#'
    },
    {
      title: 'Returns and Refunds',
      href: '#'
    },
    {
      title: 'Help and FAQ',
      href: '#'
    },
    {
      title: 'Return Points',
      href: '#'
    },
    {
      title: 'Returns and Orders',
      href: '#'
    }
  ]
};
export default CustomerServices;
